import request from "@utils/request";
import dialog from "@utils/dialog";
/**
 * 退款理由
 * @returns {*}
 */
export function getApplyGrade() {
  return request.get("/user/getApplyGrade");
}

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function postApply(data) {
  return request.post("/user/applyGrade", data, { login: true });
}
/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function getApplyList(q) {
  return request.post("/user/getApplyList", q, { login: true });
}
/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
  return request.post("/login", data, { login: false });
}

export function changeReMobile(data){
  return request.post("/changeReMobile", data, { login: false });
}
export function getReMobile(data){
  return request.post("/getReMobile", data, { login: false });
}
/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
  return request.post("/login/mobile", data, { login: false });
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
  return request.post("/register/verify", data, { login: false });
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
  return request.post("/register", data, { login: false });
}
/**
 * 新注册接口注册
 * @param data object 用户手机号 验证码 密码
 */
export function newRegister(data) {
  return request.post("/new_register", data, { login: false });
}

/**
 * 新注册接口注册
 * @param data object 用户手机号 验证码 密码
 */
export function userRegister(data) {
  return request.post("/user/user_register", data, { login: true });
}


/**
 * 新注册接口注册
 * @param data object 用户手机号 验证码 密码
 */
export function userRegisterList(data) {
  return request.post("/user/userRegisterList", data, { login: true });
}


/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
  return request.post("/register/reset", data, { login: false });
}
/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function user_password_reset(data) {
  return request.post("/user/user_password_reset", data, { login: true });
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function payPasswordReset(data) {
  return request.post("/user/pay_password_reset", data, { login: true });
}
/*
 * 领取优惠券列表
 * */
export function getCoupon(q) {
  return request.get("/coupons", q, { login: false });
}

/*
 * 点击领取优惠券
 * */
export function getCouponReceive(id) {
  return request.post("/coupon/receive", { couponId: id }, { login: true });
}

/*
 * 批量领取优惠券
 * */
export function couponReceiveBatch(couponId) {
  return request.post("/coupon/receive/batch", { couponId });
}

/*
 * 我的优惠券
 * */
export function getCouponsUser(type) {
  return request.get("/coupons/user/" + type);
}


/*
 * 个人中心
 * */
export function getLuckList() {
  return request.get("/getLuckList");
}
/*
 * 个人中心
 * */
export function getLuck() {
  return request.get("/getLuck");
}

/*
 * 个人中心
 * */
export function getMyLuckyList(data) {
  return request.post("/getMyLuckyList", data, { login: true });
}

/*
 * 个人中心
 * */
export function getUser() {
  return request.get("/user");
}
/*
 * 个人中心
 * */
export function getUserOpenId() {
    return request.get("/useropendid");
}
/**
 * 协议
 */
export function userXieyi(){
    return request.get("/xieyi");
}
/**
 * 协议
 */
export function userXieyiZg(){
    return request.get("/xieyizg");
}

/*
 * 用户信息
 * */
export function getUserInfo() {
  return request.get("/userinfo");
}

/*
 * 个人中心(功能列表)
 * */
export function getMenuUser() {
  return request.get("/menu/user");
}

/*
 * 地址列表
 * */
export function getAddressList(data) {
  return request.get("/address/list", data || {});
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
  return request.post("/address/del", { id: id });
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
  return request.post("/address/default/set", { id: id });
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
  return request.get("/address/default");
}

/*
 * 获取单个地址
 * */
export function getAddress(id) {
  return request.get("/address/detail/" + id);
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
  return request.post("/address/edit", data);
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
  return request.get("/collect/user", { page: page, limit: limit });
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id, category) {
  return request.post("/collect/del", { id: id, category: category });
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
  return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function getCollectAdd(id, category) {
  return request.post("collect/add", { id: id, category: category });
}

/*
 * 签到配置
 * */
export function getSignConfig() {
  return request.get("/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
  return request.get("/sign/list", { page: page, limit: limit });
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
  return request.get("/sign/month", { page: page, limit: limit });
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
  return request.post("/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
  return request.post("/sign/integral", sign);
}

/*
 * 分享数据
 * */
export function getSpreadInfo() {
  return request.get("/commission");
}

/*
 * 分享人列表
 * */
export function getSpreadUser(screen) {
  return request.post("/spread/people", screen);
}
/*
 * 安置人列表
 * */
export function getNetworkUser(screen) {
  return request.post("/network/people", screen);
}
/*
 * 安置人列表
 * */
export function DelUser(uid) {
  return request.post("/register/del_user", { uid: uid});
}
export function cancelDelHandle(uid) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认注销此账号?",
      opts() {
        DelUser(uid)
            .then(res => {
              dialog.success("注销成功");
              resolve(res);
            })
            .catch(err => {
              dialog.error(err.msg);
              reject(err);
            });
      }
    });
  });
}
/*
 * 分享人订单
 * */
export function getSpreadOrder(where) {
  return request.post("/spread/order", where);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(q, types) {
  return request.get("/spread/commission/" + types, q);
}
export function getBill( types) {
  return request.get("/spread/bill/" + types);
}
/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionGrowth(q) {
  return request.get("/spread/commission_growth", q);
}
/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getBonusList(q) {
  return request.get("/spread/bonusList", q);
}
export function getBonusListDay(q) {
    return request.get("/spread/bonusListDay", q);
}
export function getBonusListWeek(q) {
  return request.get("/spread/bonusListWeek", q);
}

export function getBonusListMonth(q) {
    return request.get("/spread/bonusListMonth", q);
}
export function getIncomeList(q) {
    return request.get("/spread/incomeList", q);
}
export function getIncomeListDay(q) {
    return request.get("/spread/incomeListDay", q);
}
export function getIncomeListMonth(q) {
    return request.get("/spread/incomeListMonth", q);
}
export function getIncomeListWeek(q) {
  return request.get("/spread/incomeListWeek", q);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getExtractList(q) {
  return request.get("/extract/list", q);
}
export function getTransferList(q) {
  return request.get("/transfer/list", q);
}
export function getChange() {
  return request.get("/change/getChange");
}
export function postChangeInfo(data){
  return request.post("/change/save",data);
}

export function getChangeList(q) {
  return request.get("/change/list", q);
}
/*
 * 积分记录
 * */
export function getIntegralList(q) {
  return request.get("/integral/list", q);
}

/*
 * 提现银行
 * */
export function getBank() {
  return request.get("/extract/bank");
}
export function getMoney(data){
  return request.post("/extract/getmoney",data);
}

/*
 * 提现申请
 */
export function postCashInfo(cash) {
  return request.post("/extract/cash", cash);
}

/*
 * 获取转账
 */
export function getTransfer() {
    return request.get("/transfer/gettransfer");
}
export function getOtherAccount(data){
  return request.post("/transfer/getOtherAccount",data);
}
export function getOtherAccountNew(data){
  return request.post("/transfer/getOtherAccountNew",data);
}
export function postTransferInfo(data){
  return request.post("/transfer/save",data);
}

/*
 * 会员中心
 * */
export function getVipInfo() {
  return request.get("/user/level/grade");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
  return request.get("/user/level/task/" + id);
}

/*
 * 资金统计
 * */
export function getBalance() {
  return request.get("/user/balance");
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
  return request.get("/user/activity", {}, { login: false });
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
  return request.get("/spread/banner");
}

/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
  return request.post("/user/edit", data);
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
  return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
  return request.get("user/service/list");
}

/*
 * 公众号充值
 * */
export function rechargeWechat(data) {
  return request.post("/recharge/wechat", data);
}

export function rechargeList(data,types) {
    return request.post("/recharge/rechargeList/" + types, data);
}
export function rechargeListNext(data,types) {
    return request.post("/recharge/rechargeListNext/" + types, data);
}

export function cancelRechargePay(data){
  return request.post("/recharge/cancelRechargePay", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
  return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
  return request.post("binding", data);
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
  return request.post("switch_h5", { from: "wechat" });
}
/*
 * 获取分享人排行
 * */
export function getRankList(q) {
  return request.get("rank", q);
}
/*
 * 获取收益排名
 * */
export function getBrokerageRank(q) {
  return request.get("brokerage_rank", q);
}
/**
 * 检测会员等级
 */
export function setDetection() {
  return request.get("user/level/detection");
}
/**
 * 充值金额选择
 */
export function getRechargeApi(data) {
  return request.post("recharge/index",data);
}

/**
 * 验证码key
 */
export function getCodeApi() {
  return request.get("verify_code", {}, { login: false });
}


/**
 * 充值优惠处理extract/cash
 */
export function rechargeDiscount(data){
  return request.get("/recharge/discount", data);
}




/**
 * 获取售后商品信息
 */
export function getReturnProductInfo(data) {
  return request.get("/getReturnProductInfo", data, { login: true });
}

/**
 * 获取售后列表
 */
export function getOrderReturnList(data) {
  return request.get("/getOrderReturnList", data, { login: true });
}

/**
 * 获取售后原因信息
 */
export function getReturnReason() {
  return request.get("/getReturnReason", {}, { login: true });
}

/**
 * 提交售后信息
 */
export function submitOrderReturn(data) {
  return request.post("/submitOrderReturn", data, { login: true });
}

/**
 * 删除售后订单
 */
export function delOrderReturn(data) {
  return request.post("/delOrderReturn", data, { login: true });
}

/**
 * 获取售后详情信息
 */
export function getOrderReturnDetail(data) {
  return request.get("/getOrderReturnDetail", data, { login: true });
}

/**
 * 获取卖家售后地址
 */
export function getBuyerAddress(data) {
  return request.get("/getBuyerAddress", data, { login: true });
}

/**
 * 取消售后申请
 */
export function cancelOrderReturn(data) {
  return request.post("/cancelOrderReturn", data, { login: true });
}

/**
 * 获取快递列表
 */
export function getExpressList(data) {
  return request.get("/getExpressList", data, { login: true });
}

/**
 * 提交快递信息
 */
export function submitExpressInfo(data) {
  return request.post("/submitExpressInfo", data, { login: true });
}

/**
 * 获取物流详情
 */
export function getExpressDetail(data) {
  return request.get("/getExpressDetail", data, { login: true });
}


/**
 * 计算退款金额
 */
export function getRefundMoney(data) {
  return request.get("/getRefundMoney", data, { login: true });
}

/**
 * 整单售后
 */
export function returnAll(data) {
  return request.post("/allReturn", data, { login: true });
}
/**
 * 检查手机号是否注册和是否绑定微信
 */
export function checkUserBind(data) {
  return request.post("/checkUserBind",data,{login:false});
}